import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpRequest } from '@angular/common/http';

import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbSpinnerModule,
} from '@nebular/theme';
import {
  NbAuthModule,
  NbPasswordAuthStrategy,
  NbAuthJWTInterceptor,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
} from '@nebular/auth';

import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login/login.component';
import { AccountComponent } from './account.component';
import { RegisterComponent } from './register/register.component';
import { RequestPasswordComponent } from './request-password/request-password.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { RegistrationCompletedComponent } from './register/registration-completed/registration.completed.component';
import { ChangePasswordComponent } from './request-password/change-password/change-password.component';

export function filterInterceptorRequest(req: HttpRequest<any>) {
  return ['http://localhost:4400/api/auth/',
    'http://other.url/with/no/token/injected/',
  ]
    .some(url => req.url.includes(url));
}

@NgModule({
  imports: [
    HttpClientModule,
    AccountRoutingModule,
    NbCardModule,
    NbLayoutModule,
    NbListModule,
    FormsModule,
    NbAlertModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    CommonModule,
    NbSpinnerModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'password',
        }),
      ],
      forms: {},
    }),
  ],
  declarations: [
    LoginComponent,
    AccountComponent,
    RegisterComponent,
    RequestPasswordComponent,
    VerifyAccountComponent,
    RegistrationCompletedComponent,
    ChangePasswordComponent
  ],
  providers: [
    // AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true },
    { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterInterceptorRequest },
  ],
})
export class AccountModule {
}
